.assignmentsList {
	padding-bottom: 8px;

	& > * + * {
		margin-top: 24px;
	}
}